export const LADE_AUSWAHLWERTE_RESSOURCEN = "ladeAuswahlwerteRessourcen";
